import _ from "lodash";
import { ISwarmHotKeyModel } from "src/common/swarm/models/response";
import { ISelection } from "src/constants/interfaces/bet";

export const getHotKeyAndSelectionEqualityChecker = (hotKeyModel: ISwarmHotKeyModel) => (
    (selection: ISelection) => {
        const sameTypeId = hotKeyModel.SelectionTypeId === selection.event.type_id;

        if (!_.isNil(hotKeyModel.Handicap)) return sameTypeId && selection.event.base === hotKeyModel.Handicap;

        if (!_.isNil(hotKeyModel.HomeValue) && !_.isNil(hotKeyModel.AwayValue)) {
            return (
                sameTypeId
                && selection.event.home_value === hotKeyModel.HomeValue
                && selection.event.away_value === hotKeyModel.AwayValue
            );
        }

        return sameTypeId;
    }
);